import { render } from "./PolicyFilter.vue?vue&type=template&id=3be4d0f0"
import script from "./PolicyFilter.vue?vue&type=script&lang=js"
export * from "./PolicyFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__